export default function Consultant() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-3xl font-bold text-[#5A4033] text-center mb-16">
          誰が相談を受けているのか
        </h2>

        {/* 上段：テキスト左・写真右 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div className="flex flex-col justify-center">
            <p className="text-[#5A4033] leading-relaxed mb-4">
              不動産業界と建築業界の両方を、<br />
              20年以上にわたり現場で見てきたコンサルタントが対応します。
            </p>
            <p className="text-[#5A4033] leading-relaxed mb-4">
              住宅購入、建築、売却、住宅ローン。<br />
              数多くの現場で、成功と失敗の両方を見てきました。
            </p>
            <p className="text-[#5A4033] leading-relaxed mb-4">
              だからこそ、表面的なアドバイスではなく、<br />
              実務に基づいた判断ができます。
            </p>
            <p className="text-[#5A4033] leading-relaxed mb-4">
              選択肢を並べ、リスクを洗い出し、<br />
              現実的な道筋を示すことが役割です。
            </p>
            <p className="text-[#5A4033] leading-relaxed mb-4">
              お客様の状況に合わせ、<br />
              最適な進め方を一緒に設計し、<br />
              ゴールまで伴走します。
            </p>
            <p className="text-[#5A4033] leading-relaxed">
              決断を「一人で背負わせない」こと。<br />
              それがこのサービスの価値です。
            </p>
          </div>

          <div className="flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/be74474a88e32cc40cdef43b4d914c46/db076c82b40415a42db2da09b0af2a21.jpeg"
              alt="相談員"
              className="w-full max-w-[400px] h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>

        {/* 下段：保有資格左・ご相談料について右 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="bg-[#FFF8F3] rounded-2xl p-8 shadow-sm hover:shadow-md hover:scale-[1.03] transition-all duration-250 ease-out">
            <h3 className="text-[#5A4033] font-bold text-xl mb-6">保有資格</h3>
            <ul className="space-y-3">
              <li className="flex items-center">
                <div className="w-8 h-8 bg-[#8FAE9A] rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-medal-line text-white text-lg"></i>
                </div>
                <span className="text-[#5A4033]">住宅建築コーディネーター</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 bg-[#8FAE9A] rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-medal-line text-white text-lg"></i>
                </div>
                <span className="text-[#5A4033]">住宅販売士</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 bg-[#8FAE9A] rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-medal-line text-white text-lg"></i>
                </div>
                <span className="text-[#5A4033]">リフォーム提案士</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 bg-[#8FAE9A] rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-medal-line text-white text-lg"></i>
                </div>
                <span className="text-[#5A4033]">ファイナンシャルプランナー</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 bg-[#8FAE9A] rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-medal-line text-white text-lg"></i>
                </div>
                <span className="text-[#5A4033]">住宅ローンアドバイザー</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 bg-[#8FAE9A] rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-medal-line text-white text-lg"></i>
                </div>
                <span className="text-[#5A4033]">住宅ローン診断士</span>
              </li>
            </ul>
          </div>

          <div className="bg-[#FFF8F3] rounded-2xl p-8 shadow-sm hover:shadow-md hover:scale-[1.03] transition-all duration-250 ease-out">
            <h3 className="text-[#5A4033] font-bold text-xl mb-6">ご相談料について</h3>
            <p className="text-[#5A4033] leading-relaxed text-sm mb-4">
              このサポートは、単なる相談ではありません。<br />
              お客様と同じ方向を向き、成功というゴールまで伴走するコンサルティングです。
            </p>
            <p className="text-[#5A4033] leading-relaxed text-sm mb-4">
              住宅会社や不動産会社から、紹介料をいただく場合もあります。<br />
              ただし、その有無によって判断を変えることはありません。
            </p>
            <p className="text-[#5A4033] leading-relaxed text-sm mb-4">
              私たちが見るのは「誰を紹介するか」ではなく、<br />
              「お客様にとって、どの選択が最も納得できるか」です。
            </p>
            <p className="text-[#5A4033] leading-relaxed text-sm mb-4">
              情報・条件・リスクをすべて開示したうえで、<br />
              最終判断は必ずお客様自身が行います。
            </p>
            <p className="text-[#5A4033] leading-relaxed text-sm">
              だからこそ、無料ではなく相談料をいただきます。<br />
              責任を持って、最後まで伴走するための対価です。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}